import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPreview: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="preview, details"><ellipse cx="12" cy="5.25" rx="6.25" ry="2" stroke="currentColor" strokeWidth="1.5"/><path d="M18.25 9.5C18.25 10.6046 15.4518 11.5 12 11.5C8.54822 11.5 5.75 10.6046 5.75 9.5" stroke="currentColor" strokeWidth="1.5"/><path d="M5.75 5.5V10.4997L3.80161 15.1052C3.28809 16.319 3.28215 17.7333 4.29681 18.5745C5.53457 19.6006 7.84776 20.75 12 20.75C16.1522 20.75 18.4654 19.6006 19.7032 18.5745C20.7179 17.7333 20.7119 16.319 20.1984 15.1052L18.25 10.4997V5.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPreview;
